import { orderingInitialState } from '@reducers/ordering/orderingInitialState';
import { OrderingInitialState, RemoveRowItemByTempIdAction } from '@reducers/ordering/types';

export const removeItemByTempId = (
  state: OrderingInitialState,
  action: RemoveRowItemByTempIdAction
): OrderingInitialState => {
  const menus = state.orderState.menus.filter((x) => x.tempId !== action.payload.tempId);

  const count = menus.filter((x) => !x.isFreeItem).reduce((acc, curr) => acc + (curr.count || 0), 0);

  if (count === 0) return orderingInitialState;

  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus,
    },
  };
};
